import React from 'react';

import { Reveal } from '../../../../components/Reveal';
import {
  Section,
  SectionHeading,
  SectionInner,
  SectionLead,
} from '../../styles';
import { Card, Description, Grid, Number, Title } from './styles';

const features = [
  {
    title: 'Prescrição Inteligente de Treinos',
    description:
      'Gere fichas completas em segundos considerando grupos musculares, frequência semanal e o histórico do aluno.',
  },
  {
    title: 'Anti-Evasão Inteligente',
    description:
      'Alertas automáticos para identificar e recuperar alunos em risco de abandono antes que cancelem.',
  },
  {
    title: 'Gamificação Ativa',
    description:
      'Ranking de frequência e insígnias exclusivas para manter seus alunos motivados e engajados.',
  },
  {
    title: 'Notificações Push & E-mail',
    description:
      'Disparos automáticos de lembretes de treino, avisos da academia e alertas de cobrança.',
  },
  {
    title: 'Zero Inadimplência',
    description:
      'Relatórios claros em tempo real sobre mensalidades, vencimentos e pendências financeiras.',
  },
  {
    title: 'Chat Integrado',
    description:
      'Comunicação direta em tempo real entre o aluno e a equipe de instrutores dentro do aplicativo.',
  },
];

const Features: React.FC = () => {
  return (
    <Section id="recursos" alt>
      <SectionInner>
        <SectionHeading maxWidth={760}>
          Muito além da criação de fichas de treino.
        </SectionHeading>
        <SectionLead>
          Ferramentas inteligentes projetadas para reter alunos, zerar a
          inadimplência e automatizar sua rotina.
        </SectionLead>

        <Grid>
          {features.map((feature, index) => (
            <Reveal direction="up" delay={(index % 2) * 90} key={feature.title}>
              <Card>
                {/* <Number>{String(index + 1).padStart(2, '0')}</Number> */}
                <Title>{feature.title}</Title>
                <Description>{feature.description}</Description>
              </Card>
            </Reveal>
          ))}
        </Grid>
      </SectionInner>
    </Section>
  );
};

export { Features };
